import React, { useEffect, useState } from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const AnimatedSection = ({ className, children }) => {
  const [sectionRef, sectionVisible] = useScrollAnimation(0.2);

  return (
    <section
      ref={sectionRef}
      className={`${className} scroll-fade-in ${sectionVisible ? 'visible' : ''}`}
    >
      {children}
    </section>
  );
};

const AnimatedCounter = ({ end, suffix = "", durationMs = 1800 }) => {
  const [count, setCount] = useState(0);
  const [counterRef, counterVisible] = useScrollAnimation(0.2);

  useEffect(() => {
    if (!counterVisible) return;

    let current = 0;
    const tickMs = 32;
    const totalTicks = Math.max(1, Math.floor(durationMs / tickMs));
    const step = Math.max(1, Math.ceil(end / totalTicks));
    const timer = setInterval(() => {
      current += step;
      if (current >= end) {
        current = end;
        clearInterval(timer);
      }
      setCount(current);
    }, 32);

    return () => clearInterval(timer);
  }, [counterVisible, end, durationMs]);

  return (
    <div ref={counterRef} className="text-4xl md:text-5xl font-bold text-blue-400">
      {count}
      {suffix}
    </div>
  );
};

const StatsCounterSection = () => {
  return (
    <AnimatedSection className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="text-center p-6 bg-gradient-to-br from-blue-500/10 to-transparent border border-blue-500/20 rounded-2xl hover:border-blue-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
            <AnimatedCounter end={1500} suffix="+" durationMs={1200} />
            <p className="text-gray-400 mt-2 text-lg">Projects Completed</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-500/10 to-transparent border border-blue-500/20 rounded-2xl hover:border-blue-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
            <AnimatedCounter end={17} suffix="+" durationMs={1900} />
            <p className="text-gray-400 mt-2 text-lg">Years Experience</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-500/10 to-transparent border border-blue-500/20 rounded-2xl hover:border-blue-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
            <AnimatedCounter end={10} suffix="+" durationMs={2100} />
            <p className="text-gray-400 mt-2 text-lg">Cities Served</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-blue-500/10 to-transparent border border-blue-500/20 rounded-2xl hover:border-blue-500/40 transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20">
            <AnimatedCounter end={4} durationMs={2300} />
            <p className="text-gray-400 mt-2 text-lg">Strategic Partners</p>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default StatsCounterSection;
